@use '@/sass/variables';

.details {
  margin: variables.$spacing-extra-small 0 0;
  padding-left: variables.$spacing-small;
  list-style: none;
  max-height: 12rem;
  overflow-y: auto;
  overflow-wrap: anywhere;
}

.detail {
  &::before {
    content: '•';
    margin-right: variables.$spacing-extra-small;
  }
}

.overflow {
  margin: variables.$spacing-extra-small 0 0;
  font-style: italic;
}
